import React, { ReactNode } from 'react';
import { Box, Stack, Text, List, ListItem, TextLink, MarkdownLite } from '@origin-digital/ods-core';
import { StaticPerkAccordionType } from '../../typings';

const BatteryLiteAboutPlanPerkSummary: ReactNode = <Text weight="medium">About this plan</Text>;

const BatteryLiteAboutPlanPerkBody: React.ReactNode = (
  <Stack space="medium">
    <Box>
      <List space="xxsmall">
        <ListItem>
          <Text>
            <MarkdownLite>
              Get a **$200 sign up credit** and **$1/kWh** for energy extracted from your battery
              and sent to the grid during Loop VPP events
            </MarkdownLite>
          </Text>
        </ListItem>
        <ListItem>
          <Text>Plus, still receive a competitive solar feed-in-tariff (FIT)</Text>
        </ListItem>
        <ListItem>
          <Text>
            <MarkdownLite>Before signing up confirm your **eligibility**.</MarkdownLite>
          </Text>
        </ListItem>
        <ListItem>
          <Text>
            If you do not meet the eligibility requirements or do not provide details of an eligible
            battery, your energy plan will continue, but you will not receive the benefits of VPP
            orchestration.
          </Text>
        </ListItem>
        <ListItem>
          <Text>200kWh annual cap on energy exports.</Text>
        </ListItem>
        <ListItem>
          <Text>Loop VPP can be added to any Origin electricity plan.</Text>
        </ListItem>
      </List>
      <Text>You will also need:</Text>
      <List space="xxsmall">
        <ListItem>
          <Text>
            An operational solar system of at least 5kW capacity, compatible with your solar
            battery.
          </Text>
        </ListItem>
        <ListItem>
          <Text>
            A compatible inverter and solar battery of at least 5Wh usable capacity installed at
            your home.
          </Text>
        </ListItem>
        <ListItem>
          <Text>
            <TextLink
              data-id="battery-lite-terms-link"
              href="https://www.originenergy.com.au/solar/battery-plans/lite/"
              target="_blank"
            >
              Learn more about Battery Lite works.
            </TextLink>
          </Text>
        </ListItem>
      </List>
    </Box>
  </Stack>
);

export const BatteryLiteAboutPlanPerk: StaticPerkAccordionType = {
  accordionIcon:
    'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/pictograms/pictogram_battery_wall.svg',
  accordionSummary: BatteryLiteAboutPlanPerkSummary,
  accordionBody: BatteryLiteAboutPlanPerkBody,
  accordionDataId: 'battery-lite-about-plan-perk',
  expanded: true,
  synced: true,
};
